<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="pembagianKoordinatorForm" id="pembagianKoordinatorForm" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>Pembagian Koordinator Luar Kota</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Delivery</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                                </template>
                                <v-date-picker v-model="date"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedVolume"></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Coordinator</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select v-model="selectedCoordinator" outlined dense hide-details="auto" :items="coordinators" item-value="code" item-text="name" clearable></v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4"></v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 text-end">
                        <v-col>
                            <v-btn depressed color="primary" class="d-inline" @click="refreshData">Get Data</v-btn>
                            <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col>
                            <v-card outlined>
                                <v-simple-table class="spreadsheet-table flex-table" fixed-header height="440" ref="tableKoordinator">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="header-cell text-center" colspan="2">
                                                    Sales
                                                </th>
                                                <th class="header-cell text-center" v-for="(sdate,isdate) in items.saledates" :key="isdate"
                                                    :colspan="sdate.outlets.length+5">
                                                    {{ sdate.sales_date | moment }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="header-cell text-center" colspan="2">
                                                    Expired
                                                </th>
                                                <th class="header-cell text-center" v-for="(sdate,isdate) in items.saledates" :key="isdate"
                                                    :colspan="sdate.outlets.length+5">
                                                    {{ sdate.expired_date | moment }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="header-cell text-center" colspan="2">                                                    
                                                </th>
                                                <template v-for="(sdate,isdate) in items.saledates">
                                                    <th class="header-cell text-center" :key="`${isdate}-total`">  
                                                        Total Produksi                                                  
                                                    </th>
                                                    <th class="header-cell text-center" v-for="(outlet,ioutlets) in sdate.outlets" :key="`${isdate}-${ioutlets}`">
                                                    {{ outlet.outlet_name }}
                                                    </th>
                                                    <th class="header-cell text-center" :key="`a-${isdate}`">
                                                        Total Kirim
                                                    </th>
                                                    <th class="header-cell text-center" :key="`b-${isdate}`">
                                                        Status
                                                    </th>
                                                    <th class="header-cell text-center" :key="`c-${isdate}`">
                                                        Ambil Stok
                                                    </th>
                                                    <th class="header-cell text-center" :key="`d-${isdate}`">
                                                        Gagal Kirim
                                                    </th>
                                                </template>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <template v-if="isLoading">
                                                <tr v-for="n in 7" :key="n">
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr v-for="(row, idp) in items.products" :key="`tr_${idp}`">
                                                    <td class="header-text text-no-wrap">{{ idp + 1 }}. {{ row.product_code }}</td>
                                                    <td class="header-text text-no-wrap">{{ row.product_name }}</td>
                                                    <template v-for="(sdate,isdate) in items.saledates">
                                                        <span v-show="false" :key="`x-${isdate}`">{{ qtyProduction = getQtyProduction(sdate.expired_date, row.product_code) }}</span>
                                                        <span v-show="false" :key="`y-${isdate}`">{{ qtyTotalKirim = sumTotalKirim(sdate.expired_date, row.product_code) }}</span>
                                                        <td class="spreadsheet-cell text-center" :key="`${isdate}-total`">
                                                            {{ qtyProduction }}
                                                        </td>
                                                        <td class="spreadsheet-cell text-center" v-for="(outlet,ioutlets) in sdate.outlets" :key="`${isdate}-${ioutlets}`">
                                                            <!-- <span v-show="false" :key="`y-${isdate}`">{{ qtyDelivery = getQtyDelivery(sdate.sales_date, outlet.outlet_code, row.product_code) }}</span> -->
                                                            <v-text-field :value="getQtyDelivery(sdate.sales_date, outlet.outlet_code, row.product_code)" @input="updateQtyAfterAdjustment(sdate.sales_date, outlet.outlet_code, row.product_code, $event)" class="spreadsheet-input" type="number" solo hide-details />
                                                            <span style="display: none;">{{ getQtyDelivery(sdate.sales_date, outlet.outlet_code, row.product_code) }}</span>
                                                        </td>
                                                        <td class="spreadsheet-cell text-center" :key="`a-${isdate}`">
                                                            {{ qtyTotalKirim | handleNaN }}
                                                        </td>
                                                        <td class="spreadsheet-cell text-center" :key="`b-${isdate}`">
                                                            {{ qtyProduction - qtyTotalKirim | handleNaN }}
                                                        </td>
                                                        <td class="spreadsheet-cell text-center" :key="`c-${isdate}`">
                                                            {{ (qtyProduction - qtyTotalKirim) >= 0 ? 0 : -(qtyProduction - qtyTotalKirim) | handleNaN }}
                                                        </td>
                                                        <td class="spreadsheet-cell text-center" :key="`d-${isdate}`">
                                                            {{ Math.max(0, qtyProduction - qtyTotalKirim) | handleNaN }}
                                                        </td>
                                                    </template>
                                                </tr>
                                            </template>
                                        </tbody>
                                        
                                        <tfoot>
                                            <tr>
                                                <th class="header-text text-right" colspan="2">Jumlah Total</th>
                                                <template v-for="(sdate,isdate) in items.saledates">
                                                    <span v-show="false" :key="`x-${isdate}`">{{ varTotalProduction = totalQtyProduction(sdate.expired_date) }}</span>
                                                    <span v-show="false" :key="`y-${isdate}`">{{ varTotalKirim = totalTotalKirim(sdate.sales_date) }}</span>
                                                    <th class="spreadsheet-cell text-center" :key="`${isdate}-total`">
                                                        {{ varTotalProduction }}
                                                    </th>
                                                    <th class="spreadsheet-cell text-center" v-for="(outlet,ioutlets) in sdate.outlets" :key="`${isdate}-${ioutlets}`">
                                                        {{ totalQtyDelivery(sdate.sales_date, outlet.outlet_code) | handleNaN }}
                                                    </th>
                                                    <th class="spreadsheet-cell text-center" :key="`a-${isdate}`">
                                                        {{ varTotalKirim | handleNaN }}
                                                    </th>
                                                    <th class="spreadsheet-cell text-center" :key="`b-${isdate}`">
                                                        {{ varTotalProduction - varTotalKirim | handleNaN }}
                                                    </th>
                                                    <th class="spreadsheet-cell text-center" :key="`c-${isdate}`">
                                                        {{ sumAmbilStok(sdate.expired_date) | handleNaN }}
                                                    </th>
                                                    <th class="spreadsheet-cell text-center" :key="`d-${isdate}`">
                                                        {{ sumGagalKirim(sdate.expired_date) | handleNaN }}
                                                    </th>

                                                </template>
                                            </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveData" class="px-6">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            valid: true,
            date: '',
            dateMenu: false,
            isLoading: false,
            saveProgress: false,
            items: {
                productions: [],
                deliveries: [],
                products: [],
                saledates: [],
            },
            coordinators: [],
            outlets: [],
            itemsPO: [],
            bottles: [],
            selectedVolume: '350',
            selectedCoordinator: '',
            expiredDate: '',
            reqRule: [v => !!v || 'Harus diisi!'],
            numberRule: val => {
                if (val < 0) return 'Tidak boleh kurang dari 0'
                return true
            },
            orderId: '',
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('D MMM YYYY');
        },
        numbers: function (number) {
            return Number(number).toLocaleString()
        },
        handleNaN: function (value) {
            return isNaN(value) ? 0 : value;
        },
    },

    computed: {

    },

    async created() {
        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;
        this.getBottles();
        this.date = moment().format('YYYY-MM-DD');

        // this.fetchPembagianKoordinator();
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        convertOutlets(data) {
            const result = Object.values(
                data.reduce((acc, item) => {
                    const key = `${item.sales_date}_${item.delivery_date}_${item.expired_date}`;
                    if (!acc[key]) {
                    acc[key] = {
                        sales_date: item.sales_date,
                        delivery_date: item.delivery_date,
                        expired_date: item.expired_date,
                        outlets: []
                    };
                    }
                    acc[key].outlets.push({
                        code: item.code,
                        outlet_code: item.outlet_code,
                        outlet_name: item.outlet_name
                    });
                    return acc;
                }, {})
            );
            return result;
        },
        getQtyProduction(expiredDate, productCode) {
            let result = 0;

            const item = this.items.productions.find((row) => row.expired_date === expiredDate && row.variant_code === productCode);
            if (item) {
                result = parseInt(item.qty_ordered);
            }

            return result;
        },
        getQtyDelivery(salesDate, outletCode, productCode) {
            let result = 0;

            const item = this.items.deliveries.find((row) => 
                row.sales_date === salesDate
                && row.outlet_code === outletCode 
                && row.product_code === productCode);
            if (item) {
                result = Number(item.quantity_after_adjustment);
            }

            return result;
        },
        sumTotalKirim(expiredDate, productCode) {

            let total = this.items.deliveries.filter((row) => row.product_code === productCode && row.expired_date === expiredDate)
                .reduce((sum, row) => sum + parseInt(row.quantity_after_adjustment), 0);

            return total;
        },
        updateQtyAfterAdjustment(salesDate, outletCode, productCode, value) {
            const itemPO = this.items.deliveries.find((row) => row.sales_date === salesDate && row.outlet_code == outletCode && row.product_code === productCode);
            if (itemPO) {
                itemPO.quantity_after_adjustment = value;
            }
        },
        totalQtyProduction(expiredDate) {
            const totalQty = this.items.productions.filter((row) => row.expired_date === expiredDate)
                .reduce((total, row) => total + row.qty_ordered, 0)

            return totalQty
        },
        totalQtyDelivery(salesDate, outletCode) {
            const totalQty = this.items.deliveries.filter((row) => row.sales_date === salesDate && row.outlet_code === outletCode)
                .reduce((total, row) => total + Number(row.quantity_after_adjustment ?? 0), 0)
            return totalQty
        },
        totalTotalKirim(salesDate) {
            const totalQty = this.items.deliveries.filter((row) => row.sales_date === salesDate)
                .reduce((total, row) => total + parseInt(row.quantity_after_adjustment), 0) + 0

            return totalQty
        },
        sumGagalKirim(expiredDate) {
            // expiredDate is the key for the column
            let sum = 0;
            for (const row of this.items.products) {
                const qtyProduction = this.getQtyProduction(expiredDate, row.product_code);
                const qtyTotalKirim = this.sumTotalKirim(expiredDate, row.product_code);
                sum += Math.max(0, qtyProduction - qtyTotalKirim);
            }
            return sum;
        },
        sumAmbilStok(expiredDate) {
            let sum = 0;
            for (const row of this.items.products) {
                const qtyProduction = this.getQtyProduction(expiredDate, row.product_code);
                const qtyTotalKirim = this.sumTotalKirim(expiredDate, row.product_code);
                sum += (qtyProduction - qtyTotalKirim) >= 0 ? 0 : -(qtyProduction - qtyTotalKirim);
            }
            return sum;
        },        
        async fetchPembagianKoordinator() {
            this.isLoading = true;

            try {
                const data = (await this.$store.dispatch('pembagiankoordinatorlk/getData', {
                    date: this.date,
                    coordinator: this.selectedCoordinator === null ? '' : this.selectedCoordinator,
                    size: this.selectedVolume,
                }));
                this.items = data;
                this.items.saledates = this.convertOutlets(data.saledates);


            } catch (error) {
                console.log('Error fetching pembagian koordinator:', error);
            } finally {
                this.isLoading = false;
            }
        },        
        async saveData() {
            await this.$refs.pembagianKoordinatorForm.validate();

            if (!this.valid) return;

            // this.saveProgress = true;

            const saveItemsPO = this.items.deliveries.map((item) => {
                return {
                    'po_code': item.po_code,
                    'outlet_code': item.outlet_code,
                    'product_code': item.product_code,
                    'quantity_after_adjustment': item.quantity_after_adjustment,
                }
            });

            const payload = {
                delivery_date: this.date,
                coordinator_code: this.selectedCoordinator,
                items_po: saveItemsPO,
            };

            const result = await this.$store.dispatch('pembagiankoordinatorlk/store', payload);

            if (result.status == 200 || result.status == 201) {
                this.saved = true
                this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data berhasil diupdate'})
                this.fetchPembagianKoordinator();
            } else {
                this.saveError = true
            }

            this.saveProgress = false
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tableKoordinator.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Pembagian-Koordinator-LK.xlsx");
        },
        refreshData() {
            this.fetchPembagianKoordinator();
        },


    }
}
</script>

<style scoped>
.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 80px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  /* background-color: transparent !important; */
  background-color: yellow !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

.small-select {
  height: 40px; /* Adjust the height of the component */
}
.small-select .v-input__control {
  min-height: 40px;
  line-height: 40px;
}
</style>